import { FormFieldsetContainer } from '@styles/reusableComponents.styled';
import React, { createContext, useContext } from 'react';

const ReadOnlyContext = createContext(false);

export const useReadOnly = () => useContext(ReadOnlyContext);

export const ReadOnlyProvider: React.FC<{ readOnly: boolean; children: React.ReactNode }> = ({
  readOnly,
  children,
}) => (
  <ReadOnlyContext.Provider value={readOnly}>
    <FormFieldsetContainer disabled={readOnly}>{children}</FormFieldsetContainer>
  </ReadOnlyContext.Provider>
);
